// The Costs page, its stat cards and tables, and the "who paid" split.
import type { LineKind } from "../../../costs/CostTables";
import type { Period } from "../../../costs/model";

export default {
  period: { day: "24 hours", week: "7 days", month: "30 days", all: "All time" } satisfies Record<Period, string>,
  periodLabel: "Period",
  loadFailed: "Could not load the costs",
  dailySpend: "Daily spend",
  dailySpendDescription: "By UTC day, split by whose model key paid · API-equivalent price",
  nothingSpent: "Nothing spent yet",
  nothingSpentBody: "Agent steps record their cost when they finish.",
  costLines: "Cost lines",
  totalSpend: "Total spend",
  sinceFirst: "Since the first step",
  since: (day: string) => `Since ${day}`,
  tokens: "Tokens",
  inOut: (input: string, output: string) => `${input} in · ${output} out`,
  agentSteps: "Agent steps",
  perStep: (amount: string) => `${amount} a step on average`,
  noneFinished: "None finished",
  whoPaid: "Who paid",
  usersKey: "User's key",
  platformKey: "Platform key",
  user: "User",
  taskGroup: "Task group",
  task: "Task",
  cost: "Cost",
  steps: "Steps",
  tabs: { users: "By user", groups: "By task group", tasks: "By task" } satisfies Record<LineKind, string>,
  emptyPeriod: "Nothing was spent in this period.",
  lessThan: (amount: string) => `<${amount}`,
};
